var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutdatedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 110,
    viewBox: "0 0 112 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.1906 105.278H12.808C8.48891 105.278 4.95508 101.958 4.95508 97.9009V46.2592C4.95508 42.2017 8.48891 38.8818 12.808 38.8818H99.1906C103.51 38.8818 107.044 42.2017 107.044 46.2592V97.9009C107.044 101.958 103.51 105.278 99.1906 105.278Z",
    stroke: "#F9F3F3",
    strokeWidth: 8.92035,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7969 10.108L45.3102 38.6486L75.3279 2.9729",
    stroke: "#F9F3F3",
    strokeWidth: 5.9469,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3281 38.8818V105.278",
    stroke: "#F9F3F3",
    strokeWidth: 5.9469,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1853 61.6748C93.3749 61.6748 95.1499 59.9 95.1499 57.7108C95.1499 55.5216 93.3749 53.7468 91.1853 53.7468C88.9957 53.7468 87.2207 55.5216 87.2207 57.7108C87.2207 59.9 88.9957 61.6748 91.1853 61.6748Z",
    stroke: "#F9F3F3",
    strokeWidth: 1.84904,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1853 87.4404C93.3749 87.4404 95.1499 85.6657 95.1499 83.4764C95.1499 81.2872 93.3749 79.5125 91.1853 79.5125C88.9957 79.5125 87.2207 81.2872 87.2207 83.4764C87.2207 85.6657 88.9957 87.4404 91.1853 87.4404Z",
    fill: "#F9F3F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1853 76.5395C93.3749 76.5395 95.1499 74.7648 95.1499 72.5755C95.1499 70.3863 93.3749 68.6116 91.1853 68.6116C88.9957 68.6116 87.2207 70.3863 87.2207 72.5755C87.2207 74.7648 88.9957 76.5395 91.1853 76.5395Z",
    fill: "#F9F3F3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutdatedIcon);
export default __webpack_public_path__ + "static/media/outdatedIcon.e4d56d7b4d0e0a989cdae5dcf731b6cf.svg";
export { ForwardRef as ReactComponent };